import { isDefined } from "@clipboard-health/util-ts";
import { FormHelperText, Stack } from "@mui/material";
import { Text, TextArea } from "@src/appV2/redesign/system/ui-components";
import { TIMEKEEPING_REASON_CONSTANTS } from "@src/appV2/redesign/WorkerShifts/Timekeeping/constants";

interface TimesheetReasonFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  disabled?: boolean;
  errorMessage?: string;
}

export function TimesheetReasonField(props: TimesheetReasonFieldProps) {
  const { value, onChange, placeholder, disabled = false, errorMessage } = props;

  const hasError = isDefined(errorMessage);

  return (
    <Stack
      spacing={2}
      sx={{
        backgroundColor: (theme) => theme.palette.background.paper,
        paddingX: 6,
        paddingY: 6,
      }}
    >
      <Text variant="body2">Write a message to the workplace reviewer*</Text>
      <TextArea
        fullWidth
        required
        value={value}
        disabled={disabled}
        placeholder={placeholder}
        rows={4}
        error={hasError}
        inputProps={{ maxLength: TIMEKEEPING_REASON_CONSTANTS.MAX_CHARACTERS }}
        onChange={(event) => {
          onChange(event.target.value);
        }}
      />
      <FormHelperText error={hasError}>
        {errorMessage ??
          `${value.length}/${TIMEKEEPING_REASON_CONSTANTS.MAX_CHARACTERS} characters`}
      </FormHelperText>
    </Stack>
  );
}
